import React, { Suspense } from 'react';
import './i18n';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GameProvider } from './context/GameContext';
import RouteGuard from './components/RouteGuard';
import Landing from './pages/Landing';
import Registration from './pages/Registration';
import Trivia from './pages/Trivia';
import Result from './pages/Result';
import Terms from './pages/Terms';

function App() {
  return (
    <Suspense fallback={<div />}>
      <GameProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route
              path="/registro"
              element={
                <RouteGuard requiredPhase="registration">
                  <Registration />
                </RouteGuard>
              }
            />
            <Route
              path="/trivia"
              element={
                <RouteGuard requiredPhase="trivia">
                  <Trivia />
                </RouteGuard>
              }
            />
            <Route
              path="/resultado"
              element={
                <RouteGuard requiredPhase="result">
                  <Result />
                </RouteGuard>
              }
            />
            <Route path="/terminos" element={<Terms />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </GameProvider>
    </Suspense>
  );
}

export default App;
